import { Box, styled } from '@mui/material';

// three columns keep the date navigation centred above the table regardless of
// the width of the button next to it
export const DateNavigationContainer = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '1fr auto 1fr',
  alignItems: 'center',
  gap: theme.spacing(2),
  marginBottom: theme.spacing(4)
}));

export const DateNavigationCenter = styled(Box)({
  gridColumn: 2,
  display: 'flex',
  justifyContent: 'center'
});

export const DateNavigationActions = styled(Box)({
  gridColumn: 3,
  display: 'flex',
  justifyContent: 'flex-end'
});

export const EllipsisBox = styled(Box)({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
});
